import { type ColorOption, ColorTone } from './colorOptions'

/**
 * api_proto.v1.Color の構造（gen_proto は company / customer 別ファイルに生成されるため
 * structural typing で両方を受け付ける）.
 *
 * `tone` を `ColorTone` ではなく `number` で受けるのは、TS の numeric enum が nominal で
 * あり「company の ColorTone」と「ai-color-modules の ColorTone」が別型になるため.
 * 生成物ごとに enum の数値は同一なので、変換はこの境界の 1 箇所だけで cast する.
 */
export interface ProtoColor {
  id: bigint
  code: string
  name: string
  hex: string
  r: number
  g: number
  b: number
  manufacturer: string
  tone: number
}

/**
 * 単一の proto Color を ColorPalette の ColorOption 形式に変換する.
 */
export const protoColorToOption = (c: ProtoColor): ColorOption => ({
  id: c.id,
  value: c.code,
  label: c.name || c.code,
  color: c.hex,
  manufacturer: c.manufacturer,
  tone: c.tone as ColorTone,
  r: c.r,
  g: c.g,
  b: c.b,
})

/**
 * proto Color の配列を ColorOption 配列に変換する.
 */
export const protoColorsToOptions = (colors: ProtoColor[]): ColorOption[] =>
  colors.map(protoColorToOption)
